import React from 'react';
import { Button, Modal, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { setIsDisposition, setisModal, setisOutbound } from '../../store/reducers/dispositionSlice';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { addId } from '../../store/reducers/aircallTagSlice';

interface ConfirmationModalProps {
  onConfirm: (isQualified: boolean) => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ onConfirm }) => {
  const isDisposition = useAppSelector((state) => state.disposition.isDisposition);
  const isModal = useAppSelector((state) => state.disposition.isModal);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setisModal(false));
  };

  const tagdatasave = () => {
    // Setting Data Read from the session storage
    const tagdata = sessionStorage.getItem('tagsdata');
    const tagdataObject = tagdata ? JSON.parse(tagdata) : {};
    const tags = tagdataObject.tags || [];
    // reservation new tags
    const Outboundtag = tags.find((tag: { name: string }) => tag.name === 'Call Dropped');
       dispatch(addId(Outboundtag.id));
    }

  return (
    <Modal open={isModal} onClose={(event, reason) => {
      if (reason === "backdropClick" || reason === "escapeKeyDown") return; // Prevent closing on backdrop click or Esc
      handleClose();
    }}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500, // Increase width
          height: 300, // Add or increase height
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: '8px',
          textAlign: 'center',
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ mb: 4 }}>
          Was this a Qualified call?
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 16, mb: 4 }}>
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              onConfirm(true);
              handleClose();
            }}
            sx={{ width: '100px' }}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onConfirm(false);
              handleClose();
            }}
            sx={{ width: '100px' }}
          >
            No
          </Button>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mb: 3 }}>
          <Typography
            variant="body2"
            sx={{
              textDecoration: 'underline',
              color: '#007bff',
              cursor: 'pointer',
            }}
            onClick={() => {
              dispatch(setisModal(false));
              dispatch(setIsDisposition(!isDisposition));
            }}
          >
            I need more time
          </Typography>
          <Typography>
            Did the call get disconnected?
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end', // Align content (button) to the right
            mb: 4, // Add margin below the button
          }}
        >
          <Button

            variant="contained"
            color='info'
            onClick={() => {
              dispatch(setisOutbound(true));
              dispatch(setisModal(false));
              tagdatasave();
            }}

          >
            Call Back
          </Button>
          </Box>
        </Box>
    </Modal>
  );
};

export default ConfirmationModal;
